import { render, staticRenderFns } from "./orderMonitor.vue?vue&type=template&id=40484331&"
import script from "./orderMonitor.vue?vue&type=script&lang=js&"
export * from "./orderMonitor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports